function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "toksqvwh9a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/suggested/plus (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h16v16H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 4693"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uD0C0\\uC6D0 105",
    style: {
      fill: "#fff",
      stroke: "#d9d9d9"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/suggested/plus"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/suggested/plus (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h16v16H0z",
    transform: "translate(4 4)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/suggested/plus",
    style: {
      clipPath: "url(#toksqvwh9a)"
    },
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/suggested/plus (clip group)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/suggested/plus (style)",
    style: {
      fill: "none"
    },
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.125 0h.938a.11.11 0 0 1 .125.125v11a.11.11 0 0 1-.125.125H.125A.11.11 0 0 1 0 11.125v-11A.11.11 0 0 1 .125 0z",
    transform: "translate(7.406 2.375)",
    style: {
      fill: "#d9d9d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M.125 0h10.5a.11.11 0 0 1 .125.125v.938a.11.11 0 0 1-.125.125H.125A.11.11 0 0 1 0 1.063V.125A.11.11 0 0 1 .125 0z",
    transform: "translate(2.625 7.406)",
    style: {
      fill: "#d9d9d9"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVertical);
export default __webpack_public_path__ + "static/media/vertical.6a3445ff67622329c042a052b8a6ea2d.svg";
export { ForwardRef as ReactComponent };